var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"poi-address",attrs:{"aria-busy":_vm.loading ? 'true' : 'false'}},[(_vm.loading)?_c('text-skeleton',{attrs:{"lines":2}}):[_vm._v(_vm._s(_vm.poi.address || '-'))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }